import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import formatNumber from "../../../utils/formatNumber";
import Style from "./NumberInput.module.css";

const NumberInput = ({
  name,
  label,
  initialValue,
  setSpecificState,
  currencySign,
  value = null,
  isError,
  isInFirstInput = false,
  maxNumber = 9999999999,
}) => {
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    const savedValue = sessionStorage.getItem(name);
    if (savedValue) {
      setInputValue(formatNumber(savedValue));
      setSpecificState(Number(savedValue));
    } else if (
      initialValue !== null &&
      initialValue !== undefined &&
      initialValue !== ""
    ) {
      setInputValue(formatNumber(initialValue.toString()));
      setSpecificState(initialValue);
    }
  }, [initialValue, name, setSpecificState]);

  const handleChange = (event) => {
    const rawValue = event.target.value;

    if (Number(rawValue.replace(/,/g, "")) > maxNumber) {
      return;
    }

    if (rawValue === "") {
      // Handle empty input differently - set to null instead of 0
      setInputValue("");
      setSpecificState(null);
      sessionStorage.removeItem(name);
    } else {
      const formattedValue = formatNumber(rawValue);
      setInputValue(formattedValue);

      // Convert to number and store
      const numericValue = Number(formattedValue.replace(/,/g, ""));
      setSpecificState(numericValue);
      sessionStorage.setItem(name, formattedValue.replace(/,/g, ""));
    }
  };

  return (
    <div className={`${Style.NumberInputContainer}`}>
      <label className={Style.NumberInputLabel}>{label}</label>
      {isError && <p className={Style.ErrorText}>Ovo polje je obavezno</p>}
      <div
        className={`${Style.NumberInputHolder} ${isError ? Style.Error : ""} ${
          isInFirstInput ? Style.firstInput : ""
        }`}
      >
        <input
          type="text"
          value={value !== null ? value : inputValue}
          onChange={handleChange}
          className={Style.NumberInputInput}
          placeholder="prazno"
        />
        <div className={Style.CurrencySign}>{currencySign}</div>
      </div>
    </div>
  );
};

NumberInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  initialValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setSpecificState: PropTypes.func.isRequired,
  currencySign: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isError: PropTypes.bool,
};

NumberInput.defaultProps = {
  initialValue: "",
  label: "",
};

export default NumberInput;
